import type { CropCreatePayload, CropListPayload, CropUpdatePayload } from "@/types";
import Crop, { CropListItem } from "../models/crop";
import Repository from "./repository";

const resource = "crops";

export default {
  // The list route returns the lean `CropListItem` shape (no tasks/affinities).
  // `harvestable_on` ("today" or "YYYY-MM-DD") restricts to crops in the ground on
  // that date whose plant has a harvest window covering it ("what can I pick?").
  async getAll(params?: {
    start_month?: string;
    end_month?: string;
    harvestable_on?: string;
    // Garden resolution in DECIMETRES; when given, each crop carries its `footprint`
    // (the plant's cell size at that resolution), else `footprint` is null.
    cell_size?: number;
  }): Promise<CropListItem[]> {
    const { data } = await Repository.get(`/${resource}/`, { params });
    return data.map((crop: CropListPayload) => new CropListItem(crop));
  },
  async get(cropId: number): Promise<Crop> {
    const { data } = await Repository.get(`/${resource}/${cropId}/`);
    return new Crop(data);
  },
  create(crop: CropCreatePayload) {
    return Repository.post(`/${resource}/`, crop);
  },
  update(cropId: number, crop: CropUpdatePayload) {
    return Repository.patch(`/${resource}/${cropId}/`, crop);
  },
  delete(cropId: number) {
    return Repository.delete(`/${resource}/${cropId}/`);
  },
};
